/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VariantGroup
 */
export interface VariantGroup {
    /**
     * 
     * @type {string}
     * @memberof VariantGroup
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VariantGroup
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof VariantGroup
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof VariantGroup
     */
    sortOrder?: number;
}

/**
 * Check if a given object implements the VariantGroup interface.
 */
export function instanceOfVariantGroup(value: object): boolean {
    return true;
}

export function VariantGroupFromJSON(json: any): VariantGroup {
    return VariantGroupFromJSONTyped(json, false);
}

export function VariantGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariantGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function VariantGroupToJSON(value?: VariantGroup | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
        'sortOrder': value['sortOrder'],
    };
}

